import Component from '@ember/component';

export default class SharedDropZoneNoPreview extends Component {}
